import { BaseCamelCasedResource } from "./BasePlainResource";
import { legacyApiResourceUrl } from "@ploy-lib/core";
class ChartResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.hasDate = false;
    }
    pk() {
        return this.id;
    }
    static async fetch(input, init) {
        const response = await super.fetch(input, init);
        return { id: typeof input === "string" ? input : input.url, ...response };
    }
    static salesOverview() {
        return this.detail().extend({
            url: () => legacyApiResourceUrl("Reporting/GetSalesOverview")
        });
    }
    static statusOverview() {
        return this.detail().extend({
            url: () => legacyApiResourceUrl("Reporting/GetStatusOverview")
        });
    }
    static financialVolumeOverview() {
        return this.detail().extend({
            url: () => legacyApiResourceUrl("Reporting/GetFinancialVolumeOverview")
        });
    }
}
ChartResource.urlRoot = legacyApiResourceUrl("Chart");
export { ChartResource };
//# sourceMappingURL=ChartResource.js.map